var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0_2020_39)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2020_39",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2020_39",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2020_39",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACYklEQVR4nO2dTWoUURhF76DNYsxUEEIGLiIbceQ0QycaJZtoXILuQuMyFLEzM3CkwECQjt0dU3W/9+47cOfFOVXVPzRd0mAwGAwGg8FgMBj8P8eSLiRdSbqWhHnnKVGPJF1KuikgnbQIk/xPBUSTGuGygGBSIxwXve2QEuFdAakcuNfqiK8FhJJ8JWwKyCT5SnBLJD2CWyDpEdzySI/gFkd6BLc00iO4hZEewS2L9AhuUaRHcEsiPYJbEOkR3HJIj+AWQ3oEtxTSI7iFkB7BLYP0CG4RpEcgfHYInx3CZ4fw2SF8dgifHcJnh/DZIXx2CJ8dwmeH8NkhfHYInx3CZ4fw2SF8dgifHcJnh/DZ6VnIiaSfI4CsZ+SuCHbcZzwLCPlXBDtu4Swk5L4IdtzCWVDItgh23MJZWMjfEey4hWM4I+9GsJMY4G4EO60F4BH/ReVUBegtAFV+9bwvPQagpQi9BqCVCD0HoIUIvQegeoSEAFSOkBKAqhFaC/CqtwitBeguQosBuopAsZ0ecOznPfz5K8V2LelF0pXgFk56BLds0iO4RZMewS2Z9AhuwaRHcMslPYJbLOkRdv12sto2C39YO9PMXBWQStEIa0krzczbAkIpeDv6sIT8iaeNPcaKBa6EbWf+as7b0fsCMikS4T756zm/wHsi6WMBmZgj7JLP3BGmh7r9Co2w3lP+rBFuXxPeSPrS4DPGNg+McKj82718ZPeRnD1Q/rRvpmPumtWe8qd9dh9ssvwfkp65D7jH29G+8p+7D7ZXdn1iHvKNEYZ8Y4QhX8szvc///ufdztYX3N+z3DOK7bUriAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFile);
export default __webpack_public_path__ + "static/media/Edit File.8f593873fdbd86ee6081678830f72427.svg";
export { ForwardRef as ReactComponent };